import { searchAutocomplete } from "services/supabaseSearch";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import SearchSuggestion from "./SearchSuggestion.jsx";
import styled from "styled-components";
import { COLORS, CONSTANTS } from "helpers/designConstants";

const SearchBar = ({ onSelectStyle }) => {
  const searchResults = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) return [];
    try {
      return await searchAutocomplete(searchTerm);
    } catch (error) {
      console.error("Search failed:", error);
      return [];
    }
  };

  return (
    <AsyncSelect
      loadOptions={searchResults}
      placeholder={"Search..."}
      // defaultValue={searchResults[0]}
      value={null}
      noOptionsMessage={() => null}
      onChange={onSelectStyle}
      components={{
        Control: ({ children, ...rest }) => (
          <components.Control {...rest}>
            <SearchIcon>
              <img src="/search.svg" alt="search" />
            </SearchIcon>
            {children}
          </components.Control>
        ),
        Option: SearchSuggestion,
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          padding: "5px 0",
          boxShadow: state.isFocused
            ? `0 0 0 1px ${COLORS.stormtechOrange}`
            : "lightgray",
          borderColor: state.isFocused ? COLORS.stormtechOrange : "lightgray",
          borderRadius: CONSTANTS.borderRadius,
          "&:hover": {
            borderColor: COLORS.stormtechOrange,
          },
        }),
        menu: (baseStyles, state) => ({
          ...baseStyles,
          "z-index": 5,
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: state.isFocused ? COLORS.secondary : "white",
        }),
      }}
    />
  );
};

const SearchIcon = styled.div`
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default SearchBar;
